import queryString from 'querystring';
import coreUtils from '@opentripplanner/core-utils';
import {
  fetchTripOptionsSuccess,
  fetchTripOptionsError,
  setCurrentQueryParam,
} from '#/trip-planner/slice';
import { FEATURE_FLAGS } from '#/shared/constants';
import { handleHttpResponse, handleGlobalError } from '#/shared/utils/http';
import { errorThrown } from '#/shared/slices/error';
import { fetchLocationLabel } from '#/shared/utils/reverse-geocoder';
import updateMicroMobilityNames from '#/trip-planner/utils/update-microbility-names';
import tripPlannerConfig from '#/trip-planner-config';
import { extractFare } from '#/shared/utils/otp2-data-helpers';

const { getRoutingParams } = coreUtils.query;
const { api: tripPlannerApi, otp2api: tripPlannerApi2 } = tripPlannerConfig;
const { MAPLIBRE_MODE } = FEATURE_FLAGS;

export const trimetLocationToOtpLocation = location => ({
  lon: location.lng,
  lat: location.lat,
  name: location.name || location.desc,
});

const getTripOptionsRequestStr = params => {
  const apiToUse = MAPLIBRE_MODE ? tripPlannerApi2 : tripPlannerApi;
  return `${apiToUse.host}${apiToUse.paths.plan}?${queryString.encode({
    ...params,
  })}`;
};

const fetchTripOptions = async params =>
  fetch(getTripOptionsRequestStr(params))
    .then(handleHttpResponse)
    .catch(handleGlobalError);

export const updateTripOptions = (currentQuery, otpUiConfig, intl) => {
  return async dispatch => {
    let tripOptionsResponse;

    try {
      tripOptionsResponse = await fetchTripOptions(
        getRoutingParams(otpUiConfig, currentQuery)
      );
    } catch {
      dispatch(errorThrown());
      return;
    }

    if (
      tripOptionsResponse === null ||
      (tripOptionsResponse || {}).error != null
    ) {
      dispatch(fetchTripOptionsError((tripOptionsResponse || {}).error));
      return;
    }

    const tripPlan = tripOptionsResponse.plan;
    tripPlan.itineraries = tripPlan.itineraries.map((it, idx) => ({
      ...it,

      // add an itinerary option ID since it doesn't come with one
      id: idx + 1,
      fare: extractFare(it),
      legs: it.legs.map(l => updateMicroMobilityNames(l, otpUiConfig, intl)),
    }));
    dispatch(fetchTripOptionsSuccess(tripPlan));
  };
};

export const getTripOptionsStr = (otpUiConfig, currentQuery) => {
  return getTripOptionsRequestStr(getRoutingParams(otpUiConfig, currentQuery));
};

export const setLocationLabel =
  (locType, { lat, lon }, next = () => {}) =>
  async (dispatch, getState) => {
    const { label, region } = await fetchLocationLabel(getState, { lat, lon });
    const location = { lon, lat, name: label, region };

    dispatch(setCurrentQueryParam({ [locType]: location }));
    next();
  };
